import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { UserListContainerService } from 'app/modules/configuration/user-list-page/user-list-container/user-list-container.service';
import { AuthService } from 'app/core/security/auth/auth.service';
import { ApiAuthService } from 'app/core/security/api/api-auth.service';
import { AuthResponse } from 'app/core/security/api/auth-response.model';
import { CookieService } from 'app/shared/services/cookie.service';
import { SwitchCompanyLoginModel } from './switch-company-login.model';
import { Router } from '@angular/router';
import { CompanyProductListService } from 'app/modules/my-services/services/company-product-list.service';

@Component({ standalone: false,
  selector: 'switch-company-login',
  templateUrl: './switch-company-login.component.html'
})
export class SwitchCompanyLoginComponent implements OnChanges {

  @Input() userId: number;
  @Input() userContactsLookupData: any[] = [];
  @Input() currentSelectedMainContactId: number;

  isError: boolean;
  dataForm: FormGroup;
  switchErrorMessage: string;

  constructor(private fb: FormBuilder,
    private userListService: UserListContainerService,
    private auth: AuthService,
    private apiAuth: ApiAuthService,
    private cookieService: CookieService,
    private router: Router,
    private companyProductListService: CompanyProductListService) {

    this.dataForm = fb.group({
      companyContactId: ['', [Validators.required]],
    });

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['userContactsLookupData'] && this.userContactsLookupData?.length >= 1) {
      this.initialiseDropDown();
    }
  }

  get companyContactId(): AbstractControl {
    return this.dataForm.controls['companyContactId'];
  }

  initialiseDropDown() {
    const index = this.userContactsLookupData.findIndex(x => x.id == this.currentSelectedMainContactId);

    if (this.currentSelectedMainContactId != null && index >= 0) {
      this.companyContactId.setValue(this.userContactsLookupData[index].id);
    }
    else {
      this.companyContactId.setValue(this.userContactsLookupData[0].id);
    }

    if (this.userContactsLookupData.length === 1) {
      this.switchCompany();
    }
  }

  switchCompany() {
    const updateModel = this.createUpdateModel();
    this.userListService.updateCompanyItem(this.userId, updateModel).then((response: any) => {
      if (response.success == true) {
        this.auth.loginWithToken(this.apiAuth.refreshToken).then((response: AuthResponse) => this.handleLoginResponse(response));
      }
    });
  }

  private createUpdateModel() {
    return new SwitchCompanyLoginModel(
      this.companyContactId.value
    )
  }

  private handleLoginResponse(response: AuthResponse) {
    if (response.isError) {
      this.handleRefreshError(response);
    } else {
      this.handleRefreshSuccess(response);
    }
  }

  private handleRefreshError(response: AuthResponse) {
    this.isError = response.isError;
    this.setErrorMessage(response.errorMessage);
  }

  private setErrorMessage(errorMessage: string) {
    this.switchErrorMessage = errorMessage;
  }

  private handleRefreshSuccess(response: AuthResponse) {
    this.auth.loggedInCompanyName = response.data['selectedCompanyName'];
    this.auth.loggedInCompanyId = response.data['selectedCompanyId'];
    this.auth.loggedInCompanyinboundRoutingNumber = response.data['inboundRoutingNumber'];
    this.auth.loggedInContactName = response.data['contactName'];
    this.cookieService.setLoggedInCompanyName(this.auth.loggedInCompanyName);
    this.cookieService.setKeyLoggedInCompanyId(this.auth.loggedInCompanyId);
    this.cookieService.setLoggedInCompanyInboundRoutingNumber(this.auth.loggedInCompanyinboundRoutingNumber);
    this.cookieService.setLoggedInContactName(this.auth.loggedInContactName);

    this.companyProductListService.companyId = this.auth.loggedInCompanyId;
    this.companyProductListService.getCompanyProductList().then((value) => {
      if (value.length == 0) {
        const redirectUrl = 'hub';
        this.router.navigate([redirectUrl]);
      }
      else {
        const redirectUrl = this.auth.getRedirectUrl();
        this.router.navigate([redirectUrl]);
      }
    });
  }
}
